import { render, staticRenderFns } from "./OilData.vue?vue&type=template&id=32014231&scoped=true"
import script from "./OilData.vue?vue&type=script&lang=js"
export * from "./OilData.vue?vue&type=script&lang=js"
import style0 from "./OilData.vue?vue&type=style&index=0&id=32014231&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32014231",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32014231')) {
      api.createRecord('32014231', component.options)
    } else {
      api.reload('32014231', component.options)
    }
    module.hot.accept("./OilData.vue?vue&type=template&id=32014231&scoped=true", function () {
      api.rerender('32014231', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Basics/BasicsEnergyData/OilData/OilData.vue"
export default component.exports